import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  banner: {
    display: "flex",
    alignItems: "center",
  },
  bannerImage: {
    position: "relative",
    width: "100%",
    height: "100vh",
    overflow: "hidden",
    "& img": {
      width: "100%"
    },
  },
  bannerText: {
    position: "absolute",
    width: "50%",
    color: "white",
    [theme.breakpoints.down(700)]: {
      width: "100%",
    },
  },
  shade: {
    position: "absolute",
    backgroundColor: "rgba(0, 0, 0, 0.3)",
    width: "100%",
    height: "100vh",
  },
  bannerTextTitle: {
    color: "black",
    fontSize: "3.5rem",
    margin: 0,
    marginBottom: "20px",
  },
  bannerTextSubTitle: {
    color: "black",
    fontSize: "1rem",
    margin: 0,
    marginBottom: "30px",
  },
  basicButton: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
    position: "relative",
    letterSpacing: "1px",
    fontWeight: "bold",
    borderRadius: "8px",
    padding: "15px 20px",
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  main: {
    position: "relative",
    width: "100%",
  },
  images: {
    position: "relative",
    marginBottom: "15px",
    "& img": {
      width: "100%",
    },
    "&:hover": {
      cursor: "zoom-in",
      transition: "0.2s",
      [theme.breakpoints.up(769)]: {
        "& $image_attr": {
          opacity: 1,
          backgroundColor: "rgba(0, 0, 0, 0.2)",
        },
      },
    },
  },
  image_attr: {
    opacity: 0,
    position: "absolute",
    top: 0,
    width: "100%",
    height: "calc(100% - 5px)",
    transition: "0.2s",
    [theme.breakpoints.down(769)]: {
      display: "none",
    },
  },
  active: {
    opacity: 1,
  },
  image_header: {
    display: "none",
    width: '100%',
    [theme.breakpoints.down(769)]: {
      display: "flex",
      marginBottom: "10px",
      justifyContent: "space-between",
      alignItems: "center",
    },
  },
  image_header_profile: {
    display: "flex",
    alignItems: "center",
    width: '100%',
    "&:hover": {
      cursor: "pointer",
    },
  },
  image_footer: {
    display: "none",
    [theme.breakpoints.down(769)]: {
      display: "block",
    },
  },
  upvote: {
    position: "absolute",
    top: "15px",
    right: "20px",
    padding: "8px 13px 3px 13px",
    fontSize: "10px",
    backgroundColor: "white",
    color: "grey",
    border: "1px solid white",
    borderRadius: "6px",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "whitesmoke",
      color: "black",
    }
  },
  profile: {
    position: "absolute",
    display: "flex",
    bottom: "15px",
    left: "15px",
    alignItems: "center",
    color: "white",
    "&:hover": {
      cursor: "pointer",
    },
  },
  profile_capt: {
    display: "flex",
    flexDirection: "column",
    width: '100%',
    marginLeft: "10px",
  },
  profile_name: {
    whiteSpace: "nowrap",
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '100%',
    fontSize: "16px",
  },
  profile_subdomain: {
    whiteSpace: "nowrap",
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '100%',
    fontSize: "12px",
    marginTop: "-3px",
  },
  container: {
    marginTop: "50px",
    "@media (max-width: 768px)": {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  copyright: {
    position: 'absolute',
    display: 'inline-block',
    width: '100%',
    bottom: '10px',
    textAlign: 'center',
    color: 'white'
  },
  contentHeader: {
    marginTop: '40px'
  }
}));

export default useStyles;
